import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs, Link } from '@material-ui/core/index';
import './breadcrumb.scss';

function Breadcrumb({ crumbs }) {
  return (
    <div className="breadcrumbs">
      <div className="u--paddingTop u--paddingBottom normalcrumbs crumbs">
        <div id="breadcrumb" className="breadcrumb">
          <Breadcrumbs aria-label="breadcrumbs">
            {crumbs.map((crumb, crumbIndex) => {
              return crumbIndex === crumbs.length - 1 ? (
                <span className="breadcrumb title--selected" key={crumb.label}>
                  {crumb.label}
                </span>
              ) : (
                <Link
                  className="breadcrumb title"
                  href={crumb.url}
                  key={crumb.label}
                >
                  {crumb.label}
                </Link>
              );
            })}
          </Breadcrumbs>
        </div>
      </div>
    </div>
  );
}
Breadcrumb.propTypes = {
  crumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
    }),
  ).isRequired,
};

Breadcrumb.defaultProps = {};

Breadcrumb.displayName = 'Breadcrumb';

export default Breadcrumb;
